// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Startwiththese_container__aohar {
  display: flex;
  justify-content: center;
  max-width: 95%;
  margin: 0 auto;
  width: 100%;
  padding: 0px;
  background-color: #1A1A1A;
  color: #fff;
}

.Startwiththese_boxedWrapper__Hy0ot {
  max-width: 100%;
  width: 100%;
  background: #1A1A1A;
  padding: 0px;
}

.Startwiththese_header__TbK4- {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0px;
}

.Startwiththese_header__TbK4- h2 {
  font-size: 20px;
  font-weight: bold;
}


.Startwiththese_viewAllButton__2KbzY {
  background: none;
  border: none;
  color: #fff;
  cursor: pointer;
  font-size: 14px;
  padding: 8px;
}


.Startwiththese_viewAllButton__2KbzY:hover {
  background-color: #555;
}

.Startwiththese_sliderContainer__aT9bt {
  display: flex;
  overflow: hidden;
}

.Startwiththese_swiper__qUPrn {
  width: 100%;
}

.Startwiththese_slide__sljXr {
  text-align: center;
}

.Startwiththese_item__9v3u3 {
  background-color: #222;
  border-radius: 10px;
  padding: 15px;
  transition: transform 0.3s ease-in-out;
}

.Startwiththese_item__9v3u3:hover {
  transform: scale(1.05);
}

.Startwiththese_image__sMK4o {
  max-width: 200px;
  width: 100%;
  height: auto;
  border-radius: 10px;
  box-shadow: 0px 4px 10px rgba(255, 255, 255, 0.2);
}
.Startwiththese_bookItem__dTUHe {
  display: block;
  border-radius: 10px;
  overflow: hidden;
  transition: transform 0.3s ease-in-out;
  cursor: pointer;
}

.Startwiththese_bookItem__dTUHe:hover {
  transform: scale(1.05);
}

.Startwiththese_bookImage__j4Gx- {
  width: 100%;
  height: auto;
  border-radius: 10px;
  box-shadow: 0px 4px 10px rgba(255, 255, 255, 0.2);
}
@media (max-width:500px){
  .Startwiththese_boxedWrapper__Hy0ot{
    padding: 0px;
    border-radius: 0;

  }
  .Startwiththese_container__aohar{
    padding: 0;
    width: 100%;
    margin: 0 auto;
  }
  .Startwiththese_header__TbK4- h2{
    font-size: 18px;
  }
}`, "",{"version":3,"sources":["webpack://./src/AudioPage/components/Css/Startwiththese.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,cAAc;EACd,cAAc;EACd,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;;AAGA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,eAAe;EACf,YAAY;AACd;;;AAGA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,sCAAsC;AACxC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iDAAiD;AACnD;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,sCAAsC;EACtC,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iDAAiD;AACnD;AACA;EACE;IACE,YAAY;IACZ,gBAAgB;;EAElB;EACA;IACE,UAAU;IACV,WAAW;IACX,cAAc;EAChB;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":[".container {\n  display: flex;\n  justify-content: center;\n  max-width: 95%;\n  margin: 0 auto;\n  width: 100%;\n  padding: 0px;\n  background-color: #1A1A1A;\n  color: #fff;\n}\n\n.boxedWrapper {\n  max-width: 100%;\n  width: 100%;\n  background: #1A1A1A;\n  padding: 0px;\n}\n\n.header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 0px;\n}\n\n.header h2 {\n  font-size: 20px;\n  font-weight: bold;\n}\n\n\n.viewAllButton {\n  background: none;\n  border: none;\n  color: #fff;\n  cursor: pointer;\n  font-size: 14px;\n  padding: 8px;\n}\n\n\n.viewAllButton:hover {\n  background-color: #555;\n}\n\n.sliderContainer {\n  display: flex;\n  overflow: hidden;\n}\n\n.swiper {\n  width: 100%;\n}\n\n.slide {\n  text-align: center;\n}\n\n.item {\n  background-color: #222;\n  border-radius: 10px;\n  padding: 15px;\n  transition: transform 0.3s ease-in-out;\n}\n\n.item:hover {\n  transform: scale(1.05);\n}\n\n.image {\n  max-width: 200px;\n  width: 100%;\n  height: auto;\n  border-radius: 10px;\n  box-shadow: 0px 4px 10px rgba(255, 255, 255, 0.2);\n}\n.bookItem {\n  display: block;\n  border-radius: 10px;\n  overflow: hidden;\n  transition: transform 0.3s ease-in-out;\n  cursor: pointer;\n}\n\n.bookItem:hover {\n  transform: scale(1.05);\n}\n\n.bookImage {\n  width: 100%;\n  height: auto;\n  border-radius: 10px;\n  box-shadow: 0px 4px 10px rgba(255, 255, 255, 0.2);\n}\n@media (max-width:500px){\n  .boxedWrapper{\n    padding: 0px;\n    border-radius: 0;\n\n  }\n  .container{\n    padding: 0;\n    width: 100%;\n    margin: 0 auto;\n  }\n  .header h2{\n    font-size: 18px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Startwiththese_container__aohar`,
	"boxedWrapper": `Startwiththese_boxedWrapper__Hy0ot`,
	"header": `Startwiththese_header__TbK4-`,
	"viewAllButton": `Startwiththese_viewAllButton__2KbzY`,
	"sliderContainer": `Startwiththese_sliderContainer__aT9bt`,
	"swiper": `Startwiththese_swiper__qUPrn`,
	"slide": `Startwiththese_slide__sljXr`,
	"item": `Startwiththese_item__9v3u3`,
	"image": `Startwiththese_image__sMK4o`,
	"bookItem": `Startwiththese_bookItem__dTUHe`,
	"bookImage": `Startwiththese_bookImage__j4Gx-`
};
export default ___CSS_LOADER_EXPORT___;
